import { render, staticRenderFns } from "./ArchitectsView.vue?vue&type=template&id=452e62bb&scoped=true&lang=pug&"
import script from "./ArchitectsView.vue?vue&type=script&lang=js&"
export * from "./ArchitectsView.vue?vue&type=script&lang=js&"
import style0 from "./ArchitectsView.vue?vue&type=style&index=0&id=452e62bb&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e62bb",
  null
  
)

export default component.exports